import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'tags'
const verb = 'post'

export default class OspreyTagCreate extends BaseAction {
    constructor() {
        const id = '60bac4d5-17cd-482f-bd0e-ee16f0d425134'
        const path = `/${resource}`
        super(resource, verb, path, id)
        this.noCache = true
    }

    create(tag) {
        if (!tag) {
            throw new Error('Missing tag object')
        }

        this.params = {
            tag
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/tags/tags-create.js